import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";

export const SMARTSCAN_POLL_INBOX_STATUS = "SMARTSCAN_POLL_INBOX_STATUS";

export const SMARTSCAN_STATUS = {
  INPROGRESS: "INPROGRESS",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
} as const;

const service = async (data) => {
  const options: object = {
    url: "/api/EMDR/GetEMDRInboxList",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return callMvcApi(options);
};

const mock = () => Promise.resolve({ eMDRInboxList: [] });

register(SMARTSCAN_POLL_INBOX_STATUS, service, mock);
